<p-progressSpinner *ngIf="busyCombos" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>

<div class="container-novopedido flex flex-column" *ngIf="!busyCombos">
    <div class="card flex flex-column justify-content-center align-items-center">
        <h3>{{tituloPedidoSelecionado}}</h3>
    </div>

    <div class="card card-lab">
        <p-fieldset class="no-legend" legend="">
            <div> <h4>Deseja enviar o pedido para qual laboratório?</h4> </div>
            <div class="formgrid grid m-0">
                <div class="field col-12">
                    <div class="mr-2">
                        <p-dropdown  class="p-inputtext-sm"  emptyMessage="Nenhum laboratório encontrado" [options]="lojas" 
                            [(ngModel)]="laboratorioSelecionado" (onChange)="changeLaboratorio();" [disabled]="carregadoComboProduto" 
                            placeholder="Selecione um laboratório" optionLabel="nome_fantasia" [showClear]="true"
                            [virtualScroll]='!!lojas && lojas.length > 38' [virtualScrollItemSize]="38" [style]="{width:'100%'}">
                            <ng-template pTemplate="selectedItem">
                                <div  class="flex align-items-center gap-2"  *ngIf="laboratorioSelecionado">
                                    <div>{{ laboratorioSelecionado?.nome_fantasia }} - {{ laboratorioSelecionado?.cnpj ?? '' | cpfCnpj }}</div>
                                </div>
                            </ng-template>

                            <ng-template let-lab pTemplate="item">
                                <div  class="flex align-items-center gap-2 text-sm">
                                    <div>{{ lab?.nome_fantasia }} - {{ lab?.cnpj ?? '' | cpfCnpj }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown> 
                    </div>
                </div>
            </div>
        </p-fieldset> 
    </div>

    <div class="card">
        <p-fieldset class="no-legend" legend="">
            <h4>Qual loja está fazendo o pedido?</h4>
            <div class="formgrid grid m-0">
                <div class="field col-12">
                    <div class="mr-2">
                        <p-dropdown class="p-inputtext-sm" emptyMessage="Nenhuma loja encontrada" [options]="clientes" [(ngModel)]="lojaSelecionada" (onChange)="changeLoja();" [disabled]="carregadoComboProduto" placeholder="Selecione uma loja" optionLabel="nome" [showClear]='true' [virtualScroll]='!!clientes && clientes.length > 38' [virtualScrollItemSize]="38" [style]="{'width':'100%'}" [styleClass]="'text-sm'">
                            <ng-template pTemplate="selectedItem">
                                <div class="flex align-items-center gap-2" *ngIf=" lojaSelecionada">
                                    <div>{{ lojaSelecionada.nome_fantasia_social ?? lojaSelecionada.nome }} - {{ lojaSelecionada?.cnpj ?? lojaSelecionada?.cpf ?? '' | cpfCnpj }}</div>
                                </div>
                            </ng-template>

                            <ng-template let-loja pTemplate="item">
                                <div class="flex align-items-center gap-2 text-sm">
                                    <div>{{ loja?.nome_fantasia_social ?? loja.nome }} - {{ loja?.cnpj ?? loja?.cpf | cpfCnpj }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>
        </p-fieldset>
    </div>

    <p-progressSpinner *ngIf="busyComboProduto" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>

    <div *ngIf="carregadoComboProduto && !busyComboProduto">
        <app-pedido-laboratorio *ngIf="opcaoPedidoSelecionado === 'pedido_lab'" [dadosForm]="dadosForm" [comboOutrosServicos]="comboOutrosServicos" [servicosAdicionados]="produtosAdicionados" [produtosLentes]="produtosLentes"></app-pedido-laboratorio>
        <app-pedido-atacado *ngIf="opcaoPedidoSelecionado === 'pedido_atacado'" [comboOutrosServicos]="produtos" [servicosAdicionados]="produtosAdicionados"></app-pedido-atacado>

        <div class="card card-resumo">
            <p-fieldset class="no-legend" legend="">
                <h4>Resumo do pedido</h4>
                 <div class="formgrid grid m-0">
                   <div class="field col-12 md:col-12 xl:col-12">
                        <p-table [value]="produtosAdicionados" styleClass="p-datatable-striped">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Item</th>
                                    <th>Qtd</th>
                                    <th>Valor</th>
                                    <th>Desconto</th>
                                    <th>Total</th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-produto let-index="rowIndex">
                                <tr>
                                    <td>{{ produto.descricao }}</td>
                                    <td>{{ produto.quantidadeAdd }}</td>
                                    <td>{{ produto.vlr_venda_tratado | currency: 'BRL'}}</td>
                                    <td>{{ produto.desc_acresc_porcentagem ?? 0 }}%</td>
                                    <td>{{ produto.vlr_liquido_produto * produto.quantidadeAdd | currency: 'BRL' }}</td>
                                    <td><p-button *ngIf="!produto.tipo_prod" icon="pi pi-times-circle" [rounded]="true" [text]="true" severity="danger" (click)="deletarServico(produto, index);"></p-button></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div> 
                    <div class="formgrid grid w-full">
                        <div class="field resumo-pedido-totais flex flex-column col-12 xl:col-8 xl:col-offset-4"><!---->
                            <div class="total-item">
                                <p class="col-6 titulo">Qtde de itens</p>
                                <p class="col-3 valor"> {{produtosAdicionados?.length ?? 0}}</p>
                            </div>
                            <div class="total-item">
                                <p class="col-6 titulo">Desconto total</p>
                                <p class="col-3 valor">{{ descontoTotal() | currency: 'BRL' }}</p>
                            </div>
                            <div class="total-item">
                                <p class="col-6 titulo">Valor total</p>
                                <p class="col-3 valor">{{ valorTotal() | currency: 'BRL' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </p-fieldset>
        </div>

        <p-fieldset class="" legend="Observação" *ngIf="opcaoPedidoSelecionado === 'pedido_lab'">
            <div class="p-fluid formgrid m-0 grid">
                <div class="field col">
                    <textarea rows="2" cols="30" pInputTextarea [autoResize]="true" [(ngModel)]="dadosForm.observacao"></textarea>
                </div>
            </div>
        </p-fieldset>

        <div class="card card-acoes">
            <p-button label="Salvar" icon="pi pi-plus" (click)="confirmCadastrarPedido()" [disabled]="pedidoValido() === false || pedidoAprovado" [loading]="loadingSave"></p-button>
        </div>
    </div>

</div>

<div class="card flex justify-content-center">
    <p-confirmDialog #conf [style]="{width: '50vw'}">
        <ng-template pTemplate="header">
            <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                <i class="pi pi-question text-5xl"></i>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button type="button" pButton *ngIf="confirmBtnNaoVisible" label="Não" (click)="conf.reject()"></button>
            <button type="button" pButton label="Sim" (click)="conf.accept()"></button>
        </ng-template>
    </p-confirmDialog>
</div>

<p-dialog header="Header" [(visible)]="modalCadastrarPedido" class="width-modal" (onHide)="fecharModalRespostaCadastrarPedido()">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">{{lblModalSalvarPedido}}</span>
        </div>
    </ng-template>

    <p-progressSpinner *ngIf="loadingSave" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>

    <div *ngIf="!loadingSave">
        <p class="m-0">
            {{textoCadastrarNovoPedido}} <strong *ngIf="pedidoCadastrado">{{pedidoCadastrado}}</strong>
        </p>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-file-pdf" severity="info" [disabled]="loadingSave || !pdfLiberado" (click)="solicitarPDF(opcaoPedidoSelecionado)" label="Baixar PDF" ></p-button>

        <p-button icon="pi pi-check" (click)="modalCadastrarPedido = false" label="Fechar" pAutoFocus [disabled]="loadingSave"></p-button>
    </ng-template>

</p-dialog>